import { plugin, defaultConfig } from '@formkit/vue';

const formkit = {
  plugin,
  config: defaultConfig,
};

export default formkit;
